import { Font as defaultFont } from '@react-pdf/renderer';

const REQUIRED_FONT_FAMILIES = ['sans', 'serif', 'cursive'];

type PdfFontRegistry = {
  register: typeof defaultFont.register;
  getRegisteredFontFamilies?: () => string[];
};

function arePdfFontsRegistered(Font: PdfFontRegistry): boolean {
  const registeredFamilies = Font.getRegisteredFontFamilies?.() ?? [];
  return REQUIRED_FONT_FAMILIES.every((family) =>
    registeredFamilies.includes(family),
  );
}

export function registerPdfFonts(Font: PdfFontRegistry = defaultFont): void {
  if (arePdfFontsRegistered(Font)) {
    return;
  }

  Font.register({
    family: 'sans',
    fonts: [
      {
        src: require('../components/ProgramActivitySlideover/ProgramAssessmentPDF/fonts/FKGroteskNeue-Light.ttf'),
        fontWeight: 300,
      },
      {
        src: require('../components/ProgramActivitySlideover/ProgramAssessmentPDF/fonts/FKGroteskNeue-Regular.ttf'),
        fontWeight: 400,
      },
      {
        src: require('../components/ProgramActivitySlideover/ProgramAssessmentPDF/fonts/FKGroteskNeue-Regular.ttf'),
        fontWeight: 400,
        fontStyle: 'italic',
      },
      {
        src: require('../components/ProgramActivitySlideover/ProgramAssessmentPDF/fonts/FKGroteskNeue-Medium.ttf'),
        fontWeight: 500,
      },
      {
        src: require('../components/ProgramActivitySlideover/ProgramAssessmentPDF/fonts/FKGroteskNeue-Bold.ttf'),
        fontWeight: 700,
      },
    ],
  });

  Font.register({
    family: 'serif',
    fonts: [
      {
        src: require('../components/ProgramActivitySlideover/ProgramAssessmentPDF/fonts/FKRomanStandard-Light.ttf'),
        fontWeight: 300,
      },
      {
        src: require('../components/ProgramActivitySlideover/ProgramAssessmentPDF/fonts/FKRomanStandard-Regular.ttf'),
        fontWeight: 400,
      },
      {
        src: require('../components/ProgramActivitySlideover/ProgramAssessmentPDF/fonts/FKRomanStandard-Regular.ttf'),
        fontWeight: 400,
        fontStyle: 'italic',
      },
      {
        src: require('../components/ProgramActivitySlideover/ProgramAssessmentPDF/fonts/FKRomanStandard-Medium.ttf'),
        fontWeight: 500,
      },
      {
        src: require('../components/ProgramActivitySlideover/ProgramAssessmentPDF/fonts/FKRomanStandard-Bold.ttf'),
        fontWeight: 700,
      },
    ],
  });

  Font.register({
    family: 'cursive',
    fonts: [
      {
        src: require('../components/ProgramActivitySlideover/ProgramAssessmentPDF/fonts/Cursive.ttf'),
        fontWeight: 400,
      },
    ],
  });
}

registerPdfFonts();
